import { useMutation } from '@tanstack/react-query';

export default function useDeleteOrganizationApiKey() {
  const token = (document.getElementsByName('csrf-token')[0] as HTMLMetaElement).content;
  return useMutation({
    mutationFn: async () => {
      const response = await fetch(`/agent/api/organization/api_key`, {
        method: 'DELETE',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json',
          'X-CSRF-Token': token,
        },
      });

      if (!response.ok) {
        throw new Error('APIキーの削除に失敗しました');
      }

      return await response.json();
    },
  });
}
